import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  MenuCallbackArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, annualPerformanceBM, annualStatusHistroy, annualNomination } from '../../../models/slakpi';
import { division, department, geographicArea } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { uniqBy } from 'lodash';
@Component({
  selector: 'annual-performane-bm',
  templateUrl: './annual-performane-bm.component.html',
  styleUrls: ['./annual-performane-bm.component.css']
})
export class AnnualPerformanceBMComponent implements OnInit {
  
  
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  submitted: boolean = false;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  
  @ViewChild('statusUpdateTemplate', { static: false })statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  public PerformanceBM_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  btnText: string = 'Add';
  public isStart:boolean=true;
  public selectedRows: any = [];
  public division_data: any;
  public department_data: any;
  public KPIMeasure_data: any;
  public Level_data: any;
  public Type_data: any;
  public bm_data: any;
  public datasetNomination: any=[];
  data: any;
  objNomination: any = new annualNomination();
  objAnnualPerformance: any = new annualPerformanceBM();
  objStatusHistroy: any = new annualStatusHistroy();
    searchText: string;
    performanceStatusHistroyDataSet: any[];
    dataHistroy: any;
    histroyColumnDefinitions: any;
    editID: any;
    userList: any;
  login_UserID: any;
  statusDDList = [{ value: 0, text: 'Draft' },{ value: 1, text: 'Study' }, { value: 2, text: 'Pending' }, { value: 3, text: 'Completed' }]
  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  year1Label: any = '';
  year2Label: any = '';
  year3Label: any = '';
  year1Value: any = '';
  year2Value: any = '';
  year3Value: any = '';
  selectedAreaItems: any = [];
  geographicAreaList: any = [];
  editSelectedAreaItems: any = [];
  todayDate = new Date();
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Annual Performance BM");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    let year = this.todayDate.getFullYear();
    this.year1Label = year - 1;
    this.year2Label = year - 2;
    this.year3Label = year - 3;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
     
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.getDivisions();
    this.getDepartments();
    this.getKPIMeasure();
    this.getLevel();
    this.getType();
    this.getBenchmarkable();
    this.LoadPerformanceBM();
    this.getGeographicArea();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  handleSelectedRowsChanged1(e, args) {
    
    if (Array.isArray(args.rows) && this.angularGrid) {
      this.selectedRows = this.angularGrid.gridService.getSelectedRowsDataItem();
    }
  }
  

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getKPIMeasure() {
    this.KPIMeasure_data = [
      { value: 1, text: 'Yes' },
      { value: 2, text: 'No' }
    ];
  }
  getLevel() {
    this.Level_data = [
      { value: 1, text: 'Divisional' },
      { value: 2, text: 'Corporate' }
    ];
  }
  getType() {
    this.Type_data = [
      { value: 1, text: 'New' },
      { value: 2, text: 'Existing' }
    ];
  }
  getBenchmarkable() {
    this.bm_data = [
      { value: 1, text: 'Yes' },
      { value: 2, text: 'No' }
    ];
  }

  
  LoadPerformanceBM() {
    
    
   
    let inpValue = new annualPerformanceBM();
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.annualPerformanceBMUno = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getAnnualPerformanceBM(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        if (rtn_data != null && rtn_data.length > 0) {
          //niqBy(data, 'kpiUno');
        //  this.data = uniqBy(data, 'annualPerformanceBMUno');
          const mockDataset = [];
          for (let i = 0; i < rtn_data.length; i++) {
            mockDataset[i] = {
              id: rtn_data[i].annualPerformanceBMUno,
              divisionUno: rtn_data[i].divisionUno,
              divisionText: rtn_data[i].divisionText,
              departmentUno: rtn_data[i].departmentUno,
              departmentText: rtn_data[i].departmentText,
              kpiName: rtn_data[i].kpiName,
              kpiMeasure: rtn_data[i].kpiMeasure,
              level: rtn_data[i].level,
              benchmarkReason: rtn_data[i].benchmarkReason,
              type: rtn_data[i].type,
              benchMarkable: rtn_data[i].benchMarkable,
              justification: rtn_data[i].justification,
              status: rtn_data[i].status
            };
          }
          this.dataset = mockDataset;
          this.data = mockDataset;

          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.PerformanceBM_data = rtn_data;
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
         this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'divisionText', name: 'Division', field: 'divisionText', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionText', 'divisionText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'departmentText', name: 'Department', field: 'departmentText', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'departmentText', 'departmentText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'level', name: 'Level', field: 'level', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'level', 'level'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'type', name: 'Type', field: 'type', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, width: 20,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Draft')
            return '<span  class="status-area status-yellow">Draft</span>';
          else if (data.status =='Completed')
            return '<span  class="status-area status-green">Completed</span>';
          else if (data.status == 'Study')
            return '<span  class="status-area status-orange">Study</span>';
          else if (data.status == 'Pending')
            return '<span  class="status-area status-red">Pending</span>';
        

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
           
            {
              command: 'edit-row', titleKey: 'Edit_ROW', positionOrder: 64, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'green', textCssClass: 'bold',
              action: (e, args) => {
                
                this.pageAction = 'edit';
                this.selectedRows = [];
                let data = args.dataContext;
                this.objAnnualPerformance = this.PerformanceBM_data.filter((items: any) => items.annualPerformanceBMUno == data.id)[0];
                for (let x = 0; x < this.geographicAreaList.length; x++) {
                  this.geographicAreaList[x].checked = false;
                }
                this.year1Value = this.objAnnualPerformance.year1Value;
                this.year2Value = this.objAnnualPerformance.year2Value;
                this.year3Value = this.objAnnualPerformance.year3Value;

                this.year1Label = (this.objAnnualPerformance.year1Label != '' && this.objAnnualPerformance.year1Label != undefined && this.objAnnualPerformance.year1Label != null) ? this.objAnnualPerformance.year1Label : this.year1Label;
                this.year2Label = (this.objAnnualPerformance.year2Label != '' && this.objAnnualPerformance.year2Label != undefined && this.objAnnualPerformance.year2Label != null) ? this.objAnnualPerformance.year2Label : this.year2Label;
                this.year3Label = (this.objAnnualPerformance.year3Label != '' && this.objAnnualPerformance.year3Label != undefined && this.objAnnualPerformance.year3Label != null) ? this.objAnnualPerformance.year3Label : this.year3Label;

                let editAreaItems: any = [];
                editAreaItems = this.objAnnualPerformance.areaUno != null && this.objAnnualPerformance.areaUno != undefined && this.objAnnualPerformance.areaUno != '' ? this.objAnnualPerformance.areaUno.split(',') : [];

                

                if (editAreaItems.length > 0) {
                  let items = [];
                  for (var i = 0; i < editAreaItems.length; i++) {
                    items.push({
                      id: editAreaItems[i],
                      text: '',
                      checked: true
                    });
                  }
                  this.editSelectedAreaItems = items;
                }

                this.selectedAreaItems = [];
                for (let i = 0; i < this.editSelectedAreaItems.length; i++) {
                  for (let x = 0; x < this.geographicAreaList.length; x++) {
                    if (this.geographicAreaList[x].id == this.editSelectedAreaItems[i].id) {
                      this.geographicAreaList[x].checked = true;
                      this.selectedAreaItems.push(this.editSelectedAreaItems[i]);
                    }
                  }
                }
                this.objAnnualPerformance.benchMarkable = (data.benchMarkable == true) ? "Yes" : "No";
                this.objAnnualPerformance.kpiMeasure = (data.kpiMeasure == true) ? "Yes" : "No";
                this.selectedRows = data;
                
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objStatusHistroy.status = (rdata.status == '') ?'Draft':rdata.status;
                this.objStatusHistroy.comments = '';



               
                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMRequestStatusHistroy();
                this.objStatusHistroy.comments = '';
                this.modalRef = this.modalService.show(
                  this.statusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            
            { divider: true, command: '', positionOrder: 68 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 69, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                     this.deleteAnnualPerformanceBM(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              }
            },
          ],
        }
      }

    ]


  }
  openModalWithClass() {
    this.pageAction = "add";
    this.objAnnualPerformance = new annualPerformanceBM();
    this.year1Value = 0;
    this.year2Value = 0;
    this.year3Value = 0;
    for (let x = 0; x < this.geographicAreaList.length; x++) {
      this.geographicAreaList[x].checked = false;
    }
    //this.selTab = true;
    this.modalRef = this.modalService.show(
      this.addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  onSave(val) {

    if (val) {
      if (this.selectedAreaItems.length == 0) {
        this.toaster.show('error', 'Error', 'Targeted Peer Geographic Areas is Required');
        return false;
      }
      this.addEditAnnualPerformanceBM(this.objAnnualPerformance);
    }
    
    return false;
  }

  addEditAnnualPerformanceBM(data1: any) {
    
    let objAnnualPBM = new annualPerformanceBM();
    let finalArea = '';
    let selectedArea: any = [];
    for (let i = 0; i < this.selectedAreaItems.length; i++) {
      selectedArea.push(this.selectedAreaItems[i].id);
    }
    finalArea = (selectedArea.length > 0) ? selectedArea.toString() : '';
    
    objAnnualPBM = data1;
    objAnnualPBM.annualPerformanceBMUno = (this.pageAction == 'add') ? 0 : data1.annualPerformanceBMUno;
    objAnnualPBM.userUno = this.login_UserID;
    objAnnualPBM.tenantUno = this.tenantUno;
    objAnnualPBM.benchMarkable = (data1.benchMarkable=='Yes')?true:false;
    objAnnualPBM.kpiMeasure = (data1.kpiMeasure == 'Yes') ? true : false;
    objAnnualPBM.condition = (this.pageAction == 'add') ? 0 : 1;
    objAnnualPBM.status = (this.editID != null && this.editID != undefined) ? data1.status : 'Draft';
    objAnnualPBM.areaUno = finalArea;
    objAnnualPBM.year1Value = this.year1Value;
    objAnnualPBM.year1Label = this.year1Label;
    objAnnualPBM.year2Value = this.year2Value;
    objAnnualPBM.year2Label = this.year2Label;
    objAnnualPBM.year3Value = this.year3Value;
    objAnnualPBM.year3Label = this.year3Label;
    this.restApi.addEditAnnualPerformanceBM(objAnnualPBM)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.selectedRows = [];
          let message = (this.pageAction == 'add') ? 'Annual Performance Saved' : 'Annual Performance Updated';
          this.toaster.show('success', 'Success', message);
          this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadPerformanceBM(); }, 900);
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  deleteAnnualPerformanceBM(data1: any) {
    
    let objAnnualPBM = new annualPerformanceBM();

    
    objAnnualPBM = data1;
    objAnnualPBM.annualPerformanceBMUno = data1.id;
    objAnnualPBM.userUno = this.login_UserID;
    objAnnualPBM.tenantUno = this.tenantUno;
    objAnnualPBM.benchMarkable = (data1.benchMarkable == 'Yes') ? true : false;
    objAnnualPBM.kpiMeasure = (data1.kpiMeasure == 'Yes') ? true : false;
    objAnnualPBM.condition = 2;

    this.restApi.addEditAnnualPerformanceBM(objAnnualPBM)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {

          
          this.selectedRows = [];          
          this.toaster.show('success', 'Success', 'Annual Performance deleted');
         // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadPerformanceBM(); }, 900);


        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }


  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.divisionText && a.divisionText.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.departmentText && a.departmentText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.level && a.level.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.type && a.type.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.data;
  }


  onStatusSubmit(val1) {
    
    if (!val1) {
     // this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateAnnualPerformanceStatus(this.objStatusHistroy);
    }
  }
  updateAnnualPerformanceStatus(data1: any) {
    



    let obj = new annualStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments : '';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.flag = 'AnnualPerformanceBM';
    this.restApi.updateAnnualStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {

          this.toaster.show('success', 'Success', 'Status Updated.');
          this.modalRef.hide();
          this.spinner.hide();
          setTimeout(() => {
            this.objStatusHistroy = new annualStatusHistroy();

            this.LoadPerformanceBM();

          }, 500);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  loadBMRequestStatusHistroy() {
    this.spinner.show();
    let inpValue = new annualStatusHistroy();
    inpValue.flag = 'AnnualPerformanceBM';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restApi.getAnnualStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            itemUno: this.dataHistroy[i].itemUno,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.performanceStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridPerformanceStatusHistroyDefn();
        }
        else {
          this.setGridPerformanceStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridPerformanceStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'createdBy', name: 'Created By', field: 'createdBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredBy', name: 'Modifed By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredBy', 'enteredBy'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredOn', name: 'Modified On', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }
  getGeographicArea() {

    let inpValue = new geographicArea();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getGeographicArea(inpValue)
      .subscribe(data => {
        

        let rtnData: any = [];
        rtnData = data;
        let items = [];
        for (var i = 0; i < rtnData.length; i++) {
          items.push({
            id: rtnData[i].areaUno,
            text: rtnData[i].areaNameEn,
            checked: false
          });
        }
        this.geographicAreaList = items;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  selectCheckBoxMultiple(ev: any, item: any) {
    

    if (ev.currentTarget.checked) {
      item.checked = true;
      this.selectedAreaItems.push(item);
    }
    else {
      //remove from list
      this.selectedAreaItems = this.selectedAreaItems.filter((x) => x.id != item.id);
    }
  }

  isYear1NumberKey(txt, evt) {
    

    //RemoveSpecial Charecter

    txt.year1Value = (txt.year1Value.length > 0) ? txt.year1Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year1Value.replace(/[^.]/g, "").length > 1) {
      this.year1Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }
  isYear2NumberKey(txt, evt) {
    

    //RemoveSpecial Charecter

    txt.year2Value = (txt.year2Value.length > 0) ? txt.year2Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year2Value.replace(/[^.]/g, "").length > 1) {
      this.year2Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }

  isYear3NumberKey(txt, evt) {
    
    //RemoveSpecial Charecter

    txt.year3Value = (txt.year3Value.length > 0) ? txt.year3Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year3Value.replace(/[^.]/g, "").length > 1) {
      this.year3Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }
  

  
}


